import { Spacer, VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { Pressable } from "react-native";
import { ToptapProps } from "./types";
import { SpaceType } from "@components/atoms/Spacer/types";
import styled, { useTheme } from "styled-components/native";
import { useState } from "react";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTranslation } from "react-i18next";
import React from "react";
import { css } from "styled-components/native";
import Tooltip from "react-native-walkthrough-tooltip";
import { getItemTypeColor } from "@utils/product/productFormatters";

const TopTabs = ({
  testID,
  onPress,
  iconColor,
  iconName,
  text,
  textTypes,
  textColor,
  lineviewSelected,
  toolTip,
  itemType,
  fromBulkList,
  badgeCount,
}: ToptapProps & { badgeCount?: number }) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();

  const ButtonWrapper = ({ children }: { children: JSX.Element }) =>
    toolTip ? (
      <Tooltip
        isVisible={tooltipIsOpen}
        contentStyle={{ backgroundColor: theme["core-06"], width: 175 }}
        disableShadow={true}
        content={
          <VDBText color={theme["core-01"]} style={typography["Minor-R"]}>
            {t("bmh.tooltip.text")}
          </VDBText>
        }
        placement="bottom"
        onClose={() => setTooltipIsOpen(false)}
        useReactNativeModal={true}
        supportedOrientations={["portrait", "landscape"]}
        backgroundColor={"transparent"}
      >
        <Pressable testID={testID} onPress={() => setTooltipIsOpen(true)}>
          {children}
        </Pressable>
      </Tooltip>
    ) : (
      <Pressable
        testID={testID}
        style={{ alignItems: "center" }}
        onPress={onPress}
      >
        {children}
      </Pressable>
    );

  return (
    <OverLay fromBulkList={fromBulkList}>
      <RelativeContainer>
        <ButtonWrapper>
          <>
            {iconName && (
              <VDBIcon
                name={iconName}
                size={24}
                color={iconColor}
                variant={IconsVariant.VDBCustom}
              />
            )}
            {fromBulkList && <Spacer size={SpaceType.Double} />}
            <TextContainer fromBulkList={fromBulkList}>
              <VDBText type={textTypes} color={textColor}>
                {text}
              </VDBText>
            </TextContainer>
            {fromBulkList && <Spacer size={SpaceType.Double} />}
          </>
        </ButtonWrapper>

        {fromBulkList && badgeCount && (
          <Badge>
            <VDBText
              type={typography["Minor-R"]}
              color={lineviewSelected ? theme["core-05"] : theme["core-06"]}
            >
              {badgeCount}
            </VDBText>
          </Badge>
        )}
      </RelativeContainer>

      {!fromBulkList && <Spacer size={SpaceType.ExtraSmall} />}
      <LineView
        selected={lineviewSelected}
        getProductColor={getItemTypeColor(theme, itemType)}
        fromBulkList={fromBulkList}
      />
    </OverLay>
  );
};

const OverLay = styled.View<{ fromBulkList?: boolean }>`
  ${({ fromBulkList }) =>
    !fromBulkList &&
    css`
      flex: 1;
      padding-left: ${SpaceType.Basic}px;
      padding-right: ${SpaceType.Basic}px;
    `}
  align-items: center;
`;

const RelativeContainer = styled.View`
  position: relative;
  align-items: center;
  justify-content: center;
`;

const Badge = styled.View`
  position: absolute;
  top: 5px;
  right: -4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  justify-content: center;
  align-items: center;
`;

const LineView = styled.View<{
  selected: boolean;
  getProductColor?: any;
  fromBulkList?: boolean;
}>`
  height: ${SpaceType.ExtraSmall}px;
  width: 100%;
  ${({ fromBulkList }) =>
    !fromBulkList &&
    css`
      max-width: 107px;
    `}
  background-color: ${({ theme, selected, getProductColor }) =>
    selected
      ? theme.isTablet || theme.isDesktop
        ? getProductColor
        : theme["extra-01"]
      : theme["core-01"]};
  border-top-left-radius: ${SpaceType.Basic}px;
  border-top-right-radius: ${SpaceType.Basic}px;
`;

const TextContainer = styled.View<{ fromBulkList?: boolean }>`
  ${({ fromBulkList }) =>
    fromBulkList &&
    css`
      padding-horizontal: ${SpaceType.Double}px;
    `}
`;

export default TopTabs;
